export default __webpack_public_path__ + "static/temporary-results-940a06183af7bf407a77a268b776c4be.webp";